import React, { useEffect, useState } from 'react';
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import orderrefundStyle from './OrderRefundPage.module.css'
import BackBar from '../../components/BackBar/BackBar';
import { BsPrinterFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
//import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function OrderRefundPage() {
  const navigate = useNavigate();
  const { order_number } = useParams();
  const [orderData, setOrderData] = useState(null);
  const [orderDataItem, setOrderDataItem] = useState(null);
  const [refundItems, setRefundItems] = useState({});
  const [refundRemark, setRefundRemark] = useState("");
  const [refundTotal, setRefundTotal] = useState(0);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_all_orders.php?order_number=${order_number}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setOrderData(data.order);
          setOrderDataItem(data.order_items);
        }
      });
  }, [order_number]);

  const handleRefundChange = (itemId, value) => {
    const amount = parseFloat(value) || 0;

    const updated = {
      ...refundItems,
      [itemId]: amount
    };

    setRefundItems(updated);

    // calculate total
    const total = Object.values(updated).reduce((sum, val) => sum + val, 0);
    setRefundTotal(total);
  };

  const handleSubmitRefund = async () => {
    if (refundTotal <= 0) {
      alert("Please enter refund amount");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/process_refund.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            order_number,
            refund_items: refundItems,
            refund_total: refundTotal,
            refund_tax: 0,
            refund_grand_total: refundTotal,
            refund_remark: refundRemark
          })
        }
      );

      const data = await response.json();

      if (data.success) {
        alert("Refund processed successfully!");
        navigate("/EventOrdersPage");
      } else {
        alert("Refund failed!");
      }

    } catch (error) {
      console.error(error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleCancel = () => {
    if (window.confirm("Are you sure you want to cancel this refund?")) {
      setRefundItems({});
      setRefundTotal(0);
      setRefundRemark("");
      navigate("/EventOrdersPage");
    }
  };

  return (
    <>
      <AdminHeader />
      <div className={orderrefundStyle.orderrefundpage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={orderrefundStyle.orderrefundBody}>
                <div className="row">
                  <div className="col-xl-12">
                    { /*<button className={`${orderrefundStyle.orderrefundBackbtn} btn btn-primary me-auto mb-3`}>Back</button> */}
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-6">
                    <p> Customer Name: {orderData?.first_name} {orderData?.last_name}</p>
                  </div>
                  <div className="col-xl-6 text-end">
                    <p> Order Number: {orderData?.order_number} </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-12">
                    <div className="table-responsive">
                      <table className={`${orderrefundStyle.orderrefundTable} table table-striped table-bordered`}>
                        <thead>

                          <tr>
                            <th style={{ textAlign: 'center' }}>Item Number</th>
                            <th>Item</th>
                            <th style={{ textAlign: 'center' }}>Requested Quantity</th>
                            <th style={{ textAlign: 'center' }}>Price</th>
                            <th style={{ textAlign: 'center', width: '98px' }}>Refund Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderDataItem?.map((item, index) => (
                            <tr key={index}>
                              <td align="center">{item.amc_order_items_id}</td>
                              <td>{item.title}</td>
                              <td align="center">{item.quantity}</td>
                              <td align="center">${item.price}</td>
                              <td><input
                                type="number"
                                className={`${orderrefundStyle.refundtblFormControl} form-control`}
                                value={refundItems[item.amc_order_items_id] || ""}
                                onChange={(e) =>
                                  handleRefundChange(item.amc_order_items_id, e.target.value)
                                }
                              /></td>
                            </tr>
                          ))}

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-6">
                    <div className={orderrefundStyle.orderremarkBox}>
                      <h5>Refund Remark</h5>
                      <textarea className={`${orderrefundStyle.orderremarkTextarea} form-control`} rows="3"></textarea>
                    </div>
                  </div>
                  <div className="col-xl-3">
                    <div className={`${orderrefundStyle.orderrefundAmountBox}`}>
                      <div className="mb-2 row align-items-center">
                        <label className={`${orderrefundStyle.orderrefundLabel} col-sm-5 col-form-label`}>Total</label>
                        <div className="col-sm-7">
                          <span> {orderData?.total_amount} </span>
                        </div>
                      </div>
                      <div className="mb-2 row align-items-center">
                        <label className={`${orderrefundStyle.orderrefundLabel} col-sm-5 col-form-label`}>Tax</label>
                        <div className="col-sm-7">
                          <span> {orderData?.tax} </span>
                        </div>
                      </div>
                      <div className="mb-2 row align-items-center">
                        <label className={`${orderrefundStyle.orderrefundLabel} col-sm-5 col-form-label`}>Grand Total</label>
                        <div className="col-sm-7">
                          <span> {orderData?.grand_total} </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3">
                    <div className={`${orderrefundStyle.orderrefundAmountBox}`}>
                      <div className="mb-2 row align-items-center">
                        <label className={`${orderrefundStyle.orderrefundLabel} col-sm-6 col-form-label px-0`}>Refund Total</label>
                        <div className="col-sm-6">
                          <input
                            type="text"
                            className={`${orderrefundStyle.orderrefundFormcontrol} form-control`}
                            value={refundTotal.toFixed(2)}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="mb-2 row align-items-center">
                        <label className={`${orderrefundStyle.orderrefundLabel} col-sm-6 col-form-label px-0`}>Refund Tax</label>
                        <div className="col-sm-6">
                          <input type="text" className={`${orderrefundStyle.orderrefundFormcontrol} form-control`} placeholder="Demo Elementary School" />
                        </div>
                      </div>
                      <div className="mb-2 row align-items-center">
                        <label className={`${orderrefundStyle.orderrefundLabel} col-sm-6 col-form-label px-0`}>Refund Grand Total</label>
                        <div className="col-sm-6">
                          <input type="text" className={`${orderrefundStyle.orderrefundFormcontrol} form-control`} placeholder="Demo Elementary School" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={orderrefundStyle.orderrefundButtons}>
                  <div className="row g-2 mt-2">
                    <div className="col-xl-6"> </div>
                    <div className="col-xl-2">
                      <button type="button" className={`${orderrefundStyle.orderrefundprintBtn} btn btn-light`} onClick={handlePrint}>
                        <BsPrinterFill /> Print
                      </button>
                    </div>
                    <div className="col-xl-2">
                      <button type="button" className={`${orderrefundStyle.orderrefundCancelBtn} btn btn-secondary`} onClick={handleCancel}>Cancel</button>
                    </div>
                    <div className="col-xl-2">
                      <button type="button" className={`${orderrefundStyle.orderrefundSubmitBtn} btn btn-primary`} onClick={handleSubmitRefund}>Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}
